import React from "react";
import { Check, Printer } from "lucide-react";
import interior from "@/assets/interior.jpeg";
import { Reveal, SectionTitle, HotmartButton } from "./common";
import { INCLUDED, PRICE } from "@/lib/site";

export const Included = () => {
  return (
    <section id="incluye" className="bg-[hsl(var(--brand-sky))]/12 py-14 sm:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <Reveal>
          <SectionTitle
            eyebrow="Contenido del ebook"
            title="Esto es lo que recibirás"
            subtitle="Una aventura visual paso a paso, diseñada para enamorar a tu pequeño desde la primera página."
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 items-start gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <ul data-testid="included-checklist" className="space-y-3">
              {INCLUDED.map((item) => (
                <li
                  key={item}
                  className="flex items-start gap-3 rounded-2xl border border-[hsl(var(--border))] bg-white p-4 shadow-[0_6px_18px_rgba(31,41,55,0.05)]"
                >
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[hsl(var(--brand-mint))]/50">
                    <Check className="h-4 w-4 text-[hsl(var(--brand-ink))]" />
                  </span>
                  <span className="text-sm leading-relaxed text-[hsl(var(--brand-ink))] sm:text-base">{item}</span>
                </li>
              ))}
            </ul>
            <div className="mt-5 flex items-start gap-3 rounded-2xl bg-[hsl(var(--brand-sun))]/30 p-4">
              <Printer className="mt-0.5 h-5 w-5 shrink-0 text-[hsl(var(--brand-ink))]" />
              <p className="text-sm text-[hsl(var(--brand-ink))]">
                <strong>Imprímelo cuantas veces quieras.</strong> Si tu pequeño se equivoca o quiere
                repetir a los elefantes, solo imprimes otra página y ¡listo!
              </p>
            </div>
            <div className="mt-6">
              <HotmartButton testId="included-cta-button">
                Lo quiero por solo ${PRICE.offer} MXN
              </HotmartButton>
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={0.1}>
            <figure className="rounded-2xl border border-[hsl(var(--border))] bg-white p-3 shadow-[0_12px_30px_rgba(31,41,55,0.1)]">
              <img
                src={interior}
                alt="Página interior para colorear: Noé con rayos de luz desde las nubes"
                data-testid="included-preview-image"
                className="h-auto w-full rounded-xl"
                width="1400"
                height="800"
                loading="lazy"
              />
              <figcaption className="mt-3 text-center text-sm text-muted-foreground">
                Líneas limpias y simples — perfectas para sus primeras obras de arte.
              </figcaption>
            </figure>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
